export default __webpack_public_path__ + "static/media/Calender.8b338a2e.svg";